import React from "react";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import Breadcrumb from "../../components/Breadcrumb";
import CourseGridMain from "./CourseGridMain";
import ScrollToTop from "../../components/ScrollTop";
import DownloadApp from "../home/DownloadApp";
import { useLocation } from "react-router";

const CourseKid = () => {
  const location = useLocation()
  const rawSegment = location.pathname.split("/").pop() || "Courses";
  const formattedName = rawSegment.replaceAll("-", " ");
  const pageTitle = formattedName;

  return (
    <div className="courses-grid-page">
      <Header parentMenu="course" menuCategoryEnable="enable" />

      <div className="react-wrapper">
        <div className="react-wrapper-inner">
          <Breadcrumb pageTitle={pageTitle} />
          
          <CourseGridMain name={pageTitle}/>
          
          <DownloadApp />
          <ScrollToTop />
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default CourseKid;